/* import __COLOCATED_TEMPLATE__ from './device-profile-settings-offline-mode-modal.hbs'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();